import { Alert, AlertTitle } from "@material-ui/lab";
import * as React from "react";

export const AlertMessage = ({ type, content, head }) => {
  return (
    <div sx={{ width: "100%" }} spacing={2}>
      <Alert severity={type}>
        <AlertTitle>{head}</AlertTitle>
        {content}
      </Alert>
    </div>
  );
};
